var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "35px",
    viewBox: "0 0 36 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "37761060-1F4D-456F-8F6D-56FFA07A2788") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Putanja-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Saved-Itineraries-1-Copy-4",
    transform: "translate(-956.000000, -610.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(117.000000, 529.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(690.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "+",
    transform: "translate(149.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3350656,15.2606635 C34.8906492,15.2606635 35.168441,15.5371248 35.168441,16.0900474 L35.168441,19.5734597 C35.168441,20.1263823 34.8906492,20.4028436 34.3350656,20.4028436 L20.5010343,20.4028436 C20.2788009,20.4028436 20.1676842,20.5134281 20.1676842,20.7345972 L20.1676842,34.1706161 C20.1676842,34.7235387 19.8898924,35 19.3343088,35 L15.8341322,35 C15.2785486,35 15.0007568,34.7235387 15.0007568,34.1706161 L15.0007568,20.7345972 C15.0007568,20.5134281 14.8896401,20.4028436 14.6674067,20.4028436 L0.833375379,20.4028436 C0.277791793,20.4028436 0,20.1263823 0,19.5734597 L0,16.0900474 C0,15.5371248 0.277791793,15.2606635 0.833375379,15.2606635 L14.6674067,15.2606635 C14.8896401,15.2606635 15.0007568,15.150079 15.0007568,14.92891 L15.0007568,0.829383886 C15.0007568,0.276461295 15.2785486,0 15.8341322,0 L19.3343088,0 C19.8898924,0 20.1676842,0.276461295 20.1676842,0.829383886 L20.1676842,14.92891 C20.1676842,15.150079 20.2788009,15.2606635 20.5010343,15.2606635 L34.3350656,15.2606635 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c1ee638db720888b41e7315aa041c373.svg";
export { ForwardRef as ReactComponent };